import {
  IMenuItem,
  NotificationIconType,
} from "@faire/deprecated-retailer-visitor-shared/views/settings/useMenuItems";
import { Core, Decorative } from "@faire/design-tokens";
import { Caution } from "@faire/slate/icons/Caution";
import { Button } from "@faire/web/slate/Button";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import React from "react";
import styled from "styled-components";

interface INotificationIconRenderer {
  notificationIconType: IMenuItem["notificationIconType"] | undefined;
  value: string;
}

const NotificationIconRenderer: React.FC<INotificationIconRenderer> = ({
  notificationIconType,
  value,
}) => {
  if (notificationIconType === NotificationIconType.CRITICAL) {
    return <PaymentFailure data-test-id={`${value}-notification-critical`} />;
  }

  if (notificationIconType === NotificationIconType.NOTIFICATION) {
    return <NotificationIcon data-test-id={`${value}-notification`} />;
  }

  return null;
};

interface IProps {
  menuItem: IMenuItem;
  isSelected?: boolean;
}

export const MenuItem: React.FC<IProps> = ({ menuItem, isSelected }) => {
  const { path, value, handleClick, handleOnVisible } = menuItem;
  const menuRef = useDoActionWhenVisible(() => {
    handleOnVisible?.();
  });
  return (
    <StyledMenuItem
      linkTo={path}
      onClick={handleClick}
      buttonRef={menuRef}
      data-test-id={"side-bar-menu-item-" + value}
      variant="tertiary"
    >
      <Typography
        variant={isSelected ? "paragraphSansMedium" : "paragraphSansRegular"}
      >
        {menuItem.label}
      </Typography>
      <NotificationIconRenderer
        notificationIconType={menuItem.notificationIconType}
        value={menuItem.value}
      />
    </StyledMenuItem>
  );
};

const StyledMenuItem = styled(Button)`
  &&& {
    display: flex;
    align-items: center;
    margin-bottom: ${getSpacing("1x")};
    gap: ${getSpacing("1x")};
    justify-content: flex-start;
    text-decoration: none;
    color: ${Core.text.default};
    &:hover {
      text-decoration: none;
    }
  }
`;

const PaymentFailure = styled(Caution).attrs({
  color: Core.text.critical,
  fontSize: "16px",
  strokeWidth: 1.5,
})`
  position: relative;
  top: 2px;
`;

const NotificationIcon = styled.div`
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${Decorative.shade.orange};
`;
